import { FC, memo } from 'react';
import { Flex, Link, Stack, Text } from '@chakra-ui/react';

import { NavProps } from './types/NavProps';

const MobileNavComponent: FC<NavProps> = ({ navItems }) => (
  <Stack bg="white" display={{ md: 'none' }} p={4}>
    {navItems.map((navItem) => (
      <Stack key={navItem.href} gap={4}>
        <Flex alignItems="center" asChild justifyContent="space-between" py={2}>
          <Link href={navItem.href ?? '#'}>
            <Text color="gray.600" fontWeight={600}>
              {navItem.label}
            </Text>
          </Link>
        </Flex>
      </Stack>
    ))}
  </Stack>
);

export const MobileNav = memo(MobileNavComponent);
